//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {

    'use strict';

    angular.module('container.components')
        .directive('srsngTimeZone', srsngTimeZone);

    function srsngTimeZone() {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/components/time-zone/time-zone.html',
            scope: { },
            controller: controller
        };

        function controller($scope) {
            $scope.model = {
                date: new Date()
            }
        }

    }

})();

